import { useLocation } from "react-router-dom";
import useLocalStorage from "./useLocalStorage";

const usePermissions = () => {
  const storage = useLocalStorage();
  const permissions = storage.getPermissions();
  const location = useLocation();

  const getCurrentRoute = () => {
    let currentPath = location.pathname;
    const pathVariables = location.state;

    if (pathVariables) {
      Object.keys(pathVariables).forEach((key) => {
        currentPath = currentPath.replace(pathVariables[key], "*");
      });
    }

    const path = permissions?.routes.filter(
      (route) => route.path === currentPath,
    )[0];

    return path == null ? { hasAccess: false } : path;
  };

  return {
    isData: () => {
      return storage.getPermissions() === "adq_data";
    },
    isMedia: () => {
      return storage.getPermissions() === "adq_media";
    },
    isBusiness: () => {
      return storage.getPermissions() === "adq_business";
    },
    getRole: () => {
      return permissions.role;
    },
    getNavbarSections: () => {
      return permissions?.navbarSections?.filter(
        (section) => section.hasAccess === true,
      );
    },
    getRoutes: () => {
      return permissions?.routes;
    },
    hasAccess: () => {
      return getCurrentRoute().hasAccess;
    },
    canCreate: () => {
      return getCurrentRoute().canCreate;
    },
    canEdit: () => {
      return getCurrentRoute().canEdit;
    },
    canDelete: () => {
      return getCurrentRoute().canDelete;
    },
  };
};

export default usePermissions;
